export default __webpack_public_path__ + "static/media/19-100.816bea81.jpg";